import { FC, useContext } from "react";
import { Doc } from "sharedb/lib/client";

import { WorksheetType } from "../../../../shared/types/worksheet";
import { BLOCKS_PATH } from "../../../../shared/worksheets/constants";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { DocViewContext } from "providers/DocViewProvider";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsEditModeEnabled } from "store/selectors";
import { selectCurrentSectionIsArchived } from "store/selectors/current";
import { localStateActions } from "store/slices/local";

interface EmptyPageBannerProps {
  doc?: Doc<WorksheetType>;
}

export const EmptyPageBanner: FC<EmptyPageBannerProps> = ({ doc }) => {
  const dispatch = useAppDispatch();
  const { canAuthorPage } = useContext(DocViewContext);
  const isEditModeEnabled = useAppSelector(selectIsEditModeEnabled);
  const blocks = doc?.data?.[BLOCKS_PATH] || [];
  const isArchived = useAppSelector(selectCurrentSectionIsArchived);

  const showEmptyPageBanner =
    canAuthorPage && blocks.length === 0 && !isEditModeEnabled && !isArchived;

  const enableEditMode = () => {
    dispatch(localStateActions.setIsEditMode(true));
  };

  if (!showEmptyPageBanner) {
    return null;
  }

  return (
    <Banner actionButtonText={t("warning.enable_edit_mode")} kind="info" onAction={enableEditMode}>
      {t("warning.page_empty")}
    </Banner>
  );
};
